// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3528393c","453":"5feae9b3","455":"23c8267c","977":"f36894de"}[chunkId] + ".chunk.js";
};